import styled from 'styled-components';

import { COLORS, ANIM } from '../../theme/tokens';
import { coverImage } from '../../theme/mixins';
import { Text } from '../Text/Text';

export const Root = styled.button<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  border-radius: 16px;
  cursor: pointer;
  text-align: left;
  background: ${COLORS.surfaceSoft};
  border: 1px solid ${(p) => (p.$selected ? COLORS.ctaBorder : COLORS.panelBorder)};
  transition: border-color ${ANIM.INTERACT_MS}ms ease;
`;

export const Thumb = styled.div<{ $src: string }>`
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  ${(p) => coverImage(p.$src)}
`;

export const Footer = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: ${(p) => (p.$selected ? COLORS.accentMagenta : COLORS.textMuted)};
`;

export const FooterLabel = styled(Text)`
  line-height: 1;
`;
